import { v4 as uuid } from "uuid";
import { browserName } from "react-device-detect";

export const generateDeviceId = () => {
  return `${browserName}-${uuid()}`;
};

export const setDeviceId = (device_id) => {
  return localStorage.setItem("device_id", device_id);
};

export const getDeviceId = () => {
  return localStorage.getItem("device_id");
};

export const setAdminStorage = (admin, storage = "session") => {
  if (storage === "session") {
    sessionStorage.setItem("admin", JSON.stringify(admin));
  } else {
    localStorage.setItem("admin", JSON.stringify(admin));
  }
};

export const clearAdmin = () => {
  localStorage.removeItem("device_id");
  localStorage.removeItem("admin");
  sessionStorage.removeItem("admin");
};
